/* 🤖 this file was generated by svg-to-ts */
export const tmsSearch: {
    name: 'tms-search';
    data: string;
} = {
    name: 'tms-search',
    data: `<svg xmlns="http://www.w3.org/2000/svg" stroke="currentColor" viewBox="0 0 57.4 57.5"><path d="M47.5 24.7c0 12.5-10.2 22.7-22.7 22.7C12.2 47.5 2 37.3 2 24.7 2 12.2 12.2 2 24.7 2c12.6 0 22.8 10.2 22.8 22.7z" class="lens" style="fill:none;stroke-width:4;stroke-miterlimit:10"/><path d="m41.2 42.1 14.2 13.3" class="handle" style="fill:none;stroke-width:6;stroke-miterlimit:10"/></svg>`,
};
